import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import BMILogo from "../../assets/images/BMIlogo.png";
import { useAuth } from "../../routing/AuthProvider";
import {
  getUserDisplayName,
  getUserRoleLabel,
  getUserInitial,
} from "../../Utils/userUtils";

const navItems = [
  { id: "dashboard", label: "Dashboard", to: "/", icon: DashboardOutlinedIcon },
];

const Sidebar = () => {
  const auth = useAuth();
  const [logoutOpen, setLogoutOpen] = useState(false);
  const displayName = getUserDisplayName(auth.user) || "User";
  const roleLabel = getUserRoleLabel(auth.user);
  const initial = getUserInitial(auth.user);

  const handleLogoutConfirm = () => {
    setLogoutOpen(false);
    auth.logOut();
  };

  return (
    <aside className="sidebar">
      <div className="sidebar__brand">
        <img src={BMILogo} alt="BMI" />
        <div className="sidebar__brand-text">
          <span className="title">Connect</span>
          <span className="pill">Insurance Ops</span>
        </div>
      </div>

      <div className="sidebar__section">Workspace</div>
      <nav className="sidebar__nav">
        {navItems.map((item) => (
          <NavLink
            key={item.id}
            to={item.to}
            end={item.to === "/"}
            className={({ isActive }) =>
              `sidebar__nav-item${isActive ? " is-active" : ""}`
            }
          >
            <item.icon fontSize="small" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar__spacer" />

      <div className="sidebar__user">
        <div className="sidebar__user-avatar">{initial}</div>
        <div className="sidebar__user-meta">
          <span className="name">{displayName}</span>
          <span className="role">{roleLabel}</span>
        </div>
        <button
          type="button"
          className="sidebar__user-logout"
          title="Log out"
          onClick={() => setLogoutOpen(true)}
        >
          <LogoutOutlinedIcon fontSize="small" />
        </button>
      </div>

      <Dialog open={logoutOpen} onClose={() => setLogoutOpen(false)}>
        <DialogTitle>Confirm Logout</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to log out?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLogoutOpen(false)}>Cancel</Button>
          <Button onClick={handleLogoutConfirm} color="primary" autoFocus>
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </aside>
  );
};

export default Sidebar;
